import { paramsEncrypt } from '__utils/paramsEncrypt';
import { AxiosFactory } from 'emrn-api/AxiosFactory';
import { getRequestId } from 'emrn-api/getRequestId';
import { Passport } from 'emrn-hybrid/Passport';
import { Platform } from 'react-native';
import { EmContainer } from '@emcd/react-native-treasure-box/hybrid';

class ZqhdApiAxiosRequest extends AxiosFactory {
  constructor() {
    super('ZqhdApiAxiosRequest');
    this.fetch = this.fetch.bind(this);
  }

  /**
   * 获取接口数据
   * @param url 请求地址
   * @param data 请求数据
   * @param options 请求配置
   * @returns
   */
  handleFormatRequest = async (data: any) => {
    let { info } = await Passport.getUserInfo();
    return {
      ...data,
      uid: info?.uid || '',
      ct: info?.cToken || '',
      ut: info?.uToken || '',
    };
  };
  async fetch<ResponseT>(
    url: string,
    requestData: object = {},
    isEncrypt: boolean = true,
    isFormatData: boolean = true
  ) {
    const requestId = getRequestId(new Date(), 32);
    let data: any = {};
    if (isFormatData) {
      data = await this.handleFormatRequest(requestData);
      if (Platform.OS !== 'web') {
        const deviceInfo = await EmContainer.getDeviceInfo();
        data.deviceId = Platform.OS === 'ios' ? deviceInfo.idfv : deviceInfo.euid;
      }
    } else {
      data = requestData;
    }
    let headers: any = {};

    if (isEncrypt) {
      const { signature, params } = await paramsEncrypt({ ...data, acNo: 'CFFEX_CUP_WELFARE' });
      data = params;
      headers.signature = signature;
    }
    data = {
      args: {
        ...data,
      },
    };
    const axios2Res = await this.axios2<ResponseT>(
      {
        url,
        data,
        method: 'post',
        headers: {
          ...headers,
          'Content-Type': 'application/json',
        },
      },
      { requestId }
    );
    return axios2Res.data;
  }
}

export const zqhdApi = new ZqhdApiAxiosRequest();
